import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type Goal from 'webapp/models-custom/goal';

export default abstract class MobileGoalsOrMetricsListComponent<T> extends Component<T> {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('analytics') declare analyticsService: Service.Analytics;

	@tracked isOthersSectionOpen = true;

	abstract get items(): Goal[];

	abstract get favoriteItems(): Goal[];

	abstract get otherItems(): Goal[];

	get isEmpty(): boolean {
		return this.items.length === 0;
	}

	@action
	toggleOthersSection(): void {
		this.isOthersSectionOpen = !this.isOthersSectionOpen;
	}
}
